import React, { useState } from "react";
import "./register.css";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Register() {
  const [inputFirstName, setInputFirstName] = useState("");
  const [inputLastName, setInputLastName] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const handleRegister = async (event) => {
    event.preventDefault();
    try {
      const registerResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/register`,
        {
          firstname: inputFirstName,
          lastname: inputLastName,
          email: inputEmail,
          password: inputPassword,
        }
      );
      // console.log(registerResponse);
      setSuccessMessage(registerResponse.data);
      setErrorMessage("");
      setInputFirstName("");
      setInputLastName("");
      setInputEmail("");
      setInputPassword("");
    } catch (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      setSuccessMessage("");
      // setInputFirstName("");
      // setInputLastName("");
      // setInputEmail("");
      // setInputPassword("");
    }
  };
  return (
    <div className="account-login section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3 col-md-10 offset-md-1 col-12">
            <div className="register-form mt-0">
              <div className="title text-start">
                <h3>No Account? Register</h3>
                <p>
                  Registration takes less than a minute but gives you full
                  control over your orders
                </p>
              </div>
              <form
                className="row text-start"
                method="post"
                onSubmit={handleRegister}
              >
                <div className="col-sm-6 mb-3">
                  <div className="form-group">
                    <label htmlFor="reg-fn">First Name</label>
                    <input
                      onChange={(event) =>
                        setInputFirstName(event.target.value)
                      }
                      value={inputFirstName}
                      type="text"
                      className="form-control"
                      id="reg-fn"
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="reg-ln">Last Name</label>
                    <input
                      onChange={(event) => setInputLastName(event.target.value)}
                      value={inputLastName}
                      type="text"
                      className="form-control"
                      id="reg-ln"
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="reg-email">E-mail</label>
                    <input
                      onChange={(event) => setInputEmail(event.target.value)}
                      value={inputEmail}
                      type="text"
                      className="form-control"
                      id="reg-email"
                      required
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label htmlFor="reg-pass">Password</label>
                    <input
                      onChange={(event) => setInputPassword(event.target.value)}
                      value={inputPassword}
                      type="password"
                      className="form-control"
                      id="reg-pass"
                      required
                    />
                  </div>
                </div>
                <div className="button mt-4">
                  <button
                    id="register-button"
                    className="
                btn"
                    type="submit"
                  >
                    Register
                  </button>
                </div>
                {errorMessage && (
                  <p className="text-danger pt-2">{errorMessage}</p>
                )}
                {successMessage && (
                  <p className="text-success pt-2">
                    {successMessage.firstname +
                      ", you have successfully registered."}
                  </p>
                )}

                <p className="outer-link">
                  Already have an account?{" "}
                  <Link className="text-decoration-none" to="/login">
                    Login Now
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
